import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { User } from "@shared/models/user"
import groupUnlockOpenFormAction from "cc-frontend/lib/actions/group/unlock/GROUP_UNLOCK_OPEN_FORM"
import type Dispatcher from "cc-frontend/services/dispatcher"
import type ModalManager from "cc-frontend/services/modal-manager"
import styles from "./locked-group-generic.module.css"

interface Sig {
  Args: {
    user: User
  }
}

export default class LockedGroupGeneric extends Component<Sig> {
  readonly styles = styles

  @service declare modalManager: ModalManager
  @service declare dispatcher: Dispatcher

  @action unlock() {
    let form: "teacher" | "admin" | "district-admin"
    if (this.args.user.attributes.educationRole === "district-admin") {
      this.modalManager.openModal("user/unlock-group-form/district-admin", {
        user: this.args.user,
      })
      form = "district-admin"
    } else if (this.args.user.attributes.educationRole === "admin") {
      this.modalManager.openModal("user/unlock-group-form/admin", {
        user: this.args.user,
      })
      form = "admin"
    } else {
      this.modalManager.openModal("user/unlock-group-form/teacher", {
        user: this.args.user,
      })
      form = "teacher"
    }

    this.dispatcher.dispatchPreparedAction(
      groupUnlockOpenFormAction({
        form,
      })
    )
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Users::Home::LockedGroupGeneric": typeof LockedGroupGeneric
  }
}
